// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Br-w","bigColWidth":"Table_bigColWidth__JLJyR","biggerColWidth":"Table_biggerColWidth__I5thF","row":"Table_row__317ev","col":"Table_col__2eFB5"};